import axios from "axios";
import { useNavigate } from "react-router-dom";
import { authHeader } from "../../utils/helperFunction";



const AdminApi =  {
    getPlacementsDetails : () => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/admin/getPlacementDetails',
            headers : authHeader()
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
           
            return Promise.reject(e)
        })
    },
    getRequests : (status:string) => {
        return axios({
            method:'get',
            url:'https://placementportalwebservices.herokuapp.com/api/admin/getRequests',
            headers : authHeader(),
            params: {
                Status: status,
              },
        }).then(res => res.data).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    changeRequest: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/admin/changeRequest",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    newEventRequest: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/admin/newEvent",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    deleteEventRequest: (body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/admin/deleteEvent",body,{headers : authHeader()}).then(res => {
            return res
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    },
    getEventsList: (type:string) => {
        return axios({
            method:'get',
            url:"https://placementportalwebservices.herokuapp.com/api/admin/getEvents",
            headers : authHeader(),
            params: {
                type: type,
              },
        }).then(res => {
            return res.data
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })  
    },
    getShortestPath:(body:any) => {
        return axios.post("https://placementportalwebservices.herokuapp.com/api/admin/shortestPath",body,{headers : authHeader()}).then(res => {
            return res.data
        }).catch((e) => {
            if(e.response.status === 403){
                window.location.href  = "/login"
            }
            return Promise.reject(e)
        })
    }

}
export default AdminApi;